<template>
    <slot class="" v-if="settingsList">
        <div class="mb-3"
            v-for="(setting,index) in settingsList" 
            :key="index">
            <strong class="text-base sm:text-xl font-semibold text-gray-300">{{ setting.name }}</strong>
            <slot v-for="(settingOption,indexChild) in setting.children" :key="indexChild">
              <div class="text-sm sm:text-base m-4 ml-10 hover:text-gray-100 hover:font-semibold">
                <router-link
                  :to="{ name: settingOption.path}"
                  :aria-current-value="settingOption.path"
                  @click="openSettingOption(index,indexChild,settingOption.name)">
                  <i :class="settingOption.icon" class="mr-2 text-sm"></i>
                  <span> {{ settingOption.name }}</span>
                </router-link>
              </div>
            </slot>
        </div>
    </slot>
</template>

<script setup>  
</script>

<script>
  export default { 
    component() {
      groups,
      employees,
      logs,
      models,
      privileges,
      shifts
    },
    data() {
      return {
        settingsList: [],
        settingID: 0,
        headerName: '',
      }
    },
    methods: {
      openSettingOption(index,indexChild,name) {        
        this.settingID = this.settingsList[index].children[indexChild].id;
        this.headerName = name;
      },
      goBack() {
        this.settingID = 0;
      }
    },
    created() {
      if (!(this.$cookies.get('c_id'))) {
          var companyID = null;
      } else {
          var companyID = this.$cookies.get('c_id');
      }
      axios.get(baseURL+"settingsget/", {
        params: {
          action: 'settingsOptions',
          userToken: this.$cookies.get('userToken'),
          companyID: companyID
        }
      }).then(result => {
        this.settingsList = result.data;
      }, (error) => {
        console.log(error);
      })
    }
  }
</script>